module.exports = __webpack_public_path__ + "img/bg-flow.32ac31f6.png";